// Import Swiper styles
// @ts-ignore
import "swiper/swiper-bundle.min.css";
// @ts-ignore
import "./Swiper.css";
import React, { Dispatch, SetStateAction, useState } from "react";
import {
  IDocumentMediaPreviewData,
  MESSAGE_CONTENT_MEDIA_TYPE,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import MediaPreview from "./MediaPreview";
import MediaThumbPreview from "./MediaThumbPreview";

type MediaViewerProps = {
  mediaList: IDocumentMediaPreviewData[];
  activeMedia: IDocumentMediaPreviewData;
  setActiveMedia: Dispatch<SetStateAction<IDocumentMediaPreviewData>>;
  onSetMediaUrl: (url: string) => void;
};

const MediaViewer = ({
  mediaList,
  activeMedia,
  setActiveMedia,
  onSetMediaUrl,
}: MediaViewerProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(undefined);

  const supportedMediaList = mediaList.filter(media => {
    const messageContentType = media.mediaType;
    return MESSAGE_CONTENT_MEDIA_TYPE.includes(
      messageContentType as MESSAGE_CONTENT_TYPE,
    );
  });

  const findMediaMessage = (data: { realIndex: number }) => {
    const selectedMessage = supportedMediaList[data.realIndex];
    if (selectedMessage) {
      setActiveMedia(selectedMessage);
    }
  };

  const getInitialSlideIndex = (
    initialDialogMessage: IDocumentMediaPreviewData,
  ): number => {
    return initialDialogMessage
      ? mediaList.findIndex(message => message.id === initialDialogMessage.id)
      : 0;
  };
  const initialSlideIndex = getInitialSlideIndex(activeMedia);

  return (
    <>
      <MediaPreview
        mediaList={supportedMediaList}
        findMediaMessage={findMediaMessage}
        thumbsSwiper={thumbsSwiper}
        initialSlideIndex={initialSlideIndex}
        onSetMediaUrl={onSetMediaUrl}
      />
      <MediaThumbPreview
        mediaList={supportedMediaList}
        setThumbsSwiper={setThumbsSwiper}
        initialSlideIndex={initialSlideIndex}
      />
    </>
  );
};

export default MediaViewer;
